<template>
	<ui-dialog
		ref="dialog"
		closable
		title="Delete stream?"
	>
		<p>You are about to delete the stream <strong>{{ streamTitle }}</strong>, please confirm.</p>
		<ui-dialog-footer>
			<ui-button
				text="Cancel"
				tooltip="Abort deletion"
				@click="$refs.dialog.close()"
			/>
			<ui-button
				:disabled="isFetching"
				secondary
				text="Delete"
				tooltip="Delete stream"
				@click="deleteStream"
			/>
		</ui-dialog-footer>
	</ui-dialog>
</template>

<script>
import alert from "lib/modules/Alert";
import http from "lib/modules/Http";
import UiButton from "lib/components/ui/Button";
import UiDialog from "lib/components/ui/Dialog";
import UiDialogFooter from "lib/components/ui/DialogFooter";

export default {
	name: "StreamDeleteDialog",
	components: {
		UiButton,
		UiDialog,
		UiDialogFooter
	},
	data() {
		return {
			isFetching: false,
			streamId: "",
			streamTitle: ""
		};
	},
	mounted() {
		this.open = (stream) => {
			this.streamId = stream.stream_id;
			this.streamTitle = stream.title;

			this.$refs.dialog.open();
		};
	},
	methods: {
		deleteStream() {
			this.isFetching = true;

			http.delete(`/api/v2/recorder/stream/${this.streamId}`)
			.then(() => {
				this.$refs.dialog.close();
				this.$emit("delete");
			})
			.catch((error) => {
				alert.error("Unable to delete stream", error.response);
			})
			.finally(() => {
				this.isFetching = false;
			});
		}
	}
};
</script>
